import Keycloak from 'keycloak-js';
import type { KeycloakInitOptions } from 'keycloak-js';
import { appEnv } from '../lib/env';

let keycloakInstance: Keycloak | undefined;

export function getKeycloakInitOptions(): KeycloakInitOptions {
  return {
    onLoad: 'login-required',
    checkLoginIframe: false
  };
}

export function getKeycloak(): Keycloak {
  if (!keycloakInstance) {
    keycloakInstance = new Keycloak({
      realm: appEnv.irisRealm,
      url: appEnv.irisUrl,
      clientId: appEnv.irisClientId
    });
  }

  return keycloakInstance;
}

export async function verifyToken(client: Keycloak): Promise<string | undefined> {
  if (!client.authenticated || !client.token) {
    return undefined;
  }

  try {
    if (client.isTokenExpired(50)) {
      const refreshed = await client.updateToken(50);

      if (!refreshed || !client.token) {
        return undefined;
      }
    }
  } catch {
    return undefined;
  }

  return client.token;
}

export async function withVerifiedToken<T>(client: Keycloak, action: (token: string) => Promise<T>): Promise<T> {
  const token = await verifyToken(client);

  if (!token) {
    throw new Error('Authentication required. Please sign in again.');
  }

  return action(token);
}
